import { Component, OnInit, AfterViewInit, OnDestroy, ElementRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-gcse-admission',
  imports: [CommonModule, RouterModule],
  templateUrl: './gcse-admission.component.html',
  styleUrl: './gcse-admission.component.css',
})
export class GcseAdmissionComponent {
  private observer?: IntersectionObserver;

  constructor(private elRef: ElementRef) {}

  ngOnInit(): void {
    this.injectFonts();
    this.injectIcons();
  }

  ngAfterViewInit(): void {
    const revealEls = this.elRef.nativeElement.querySelectorAll('.ga-reveal');

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ga-in-view');
            this.observer?.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    revealEls.forEach((el: Element) => this.observer?.observe(el));
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }

  private injectFonts(): void {
    if (document.getElementById('ga-fonts-link')) {
      return;
    }
    const link = document.createElement('link');
    link.id = 'ga-fonts-link';
    link.rel = 'stylesheet';
    link.href = 'https://fonts.googleapis.com/css2?family=Nunito:wght@400;500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap';
    document.head.appendChild(link);
  }

  private injectIcons(): void {
    if (document.getElementById('ga-tabler-icons-link')) {
      return;
    }
    const link = document.createElement('link');
    link.id = 'ga-tabler-icons-link';
    link.rel = 'stylesheet';
    link.href = 'https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@2.47.0/tabler-icons.min.css';
    document.head.appendChild(link);
  }
}
